import React from "react";

// Exact replica tile styled like the provided mock
export default function GeneralSummaryCard({
  title,
  value,
  subtitle,
  bgClass = "bg-gray-50",
  badgeClass = "bg-white/60 border-gray-200",
  icon = "info",
}) {
  const renderIcon = (type) => {
    switch (type) {
      case "percent":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="h-4 w-4 text-gray-700"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 5L5 19M7.5 7a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm9 7a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"/></svg>
        );
      case "code":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="h-4 w-4 text-gray-700"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 18l6-6-6-6M8 6l-6 6 6 6"/></svg>
        );
      case "clock":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="h-4 w-4 text-gray-700"><circle cx="12" cy="12" r="9" strokeWidth="2"/><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 7v5l3 3"/></svg>
        );
      case "info":
      default:
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="h-4 w-4 text-gray-700"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M12 22a10 10 0 110-20 10 10 0 010 20z"/></svg>
        );
    }
  };

  return (
    <div className={`relative rounded-xl p-5 border ${bgClass} border-gray-100 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:shadow-slate-200/80`}>
      <div className="pr-10">
        <h3 className="text-[12px] font-medium text-slate-600">{title}</h3>
        <p className="mt-1 text-[22px] leading-7 font-semibold text-slate-900">{value}</p>
        <p className="mt-2 text-[11px] leading-4 text-slate-500">{subtitle}</p>
      </div>
      <div className="absolute top-4 right-4">
        <span className={`inline-flex h-9 w-9 items-center justify-center rounded-lg border ${badgeClass}`}>
          {renderIcon(icon)}
        </span>
      </div>
    </div>
  );
}
